<template>
  <div class="upload-file">
    <b-modal
      id="repRejectModal"
      centered
      size="md"
      no-close-on-backdrop
      hide-footer
      v-if="row"
    >
      <template #modal-header>
        <div class="repRejectModal-header text-center">
          <h4>Reject Request</h4>
          <b-button
            variant="close-btn"
            class="btn-container"
            @click="closeModal"
          >
            <i class="fas fa-times"></i>
          </b-button>
        </div>
      </template>
      <b-container fluid>
        <div class="repRejectModal-form">
          <div class="d-flex repApproveModal-form">
            <div class="exclaim-bg">
              <img src="../../../assets/images/exclaim.svg" />
            </div>
            <div class="">
              <div class="note-txt">
                Please note that this charge of <b>$5.00</b> will <b>NOT be applied </b> to this member card as the transaction has been rejected
              </div>
              <div class="note-txt">
                Do you want to really <b>Reject</b> the request?
                <br>
                <textarea
                :rules="{ required: true }"
                labelFor="reason"
                labelName="Reason"
                inputName="reason"
                v-model="form.admin_reason"
                formGroupClass="form-group mb-3"
                placeholder="Enter Reason"
                class="form-control mt-2" rows="4"
              />

              </div>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-end gap-2 mt-4">
            <button class="cancel-btn request-cancel m-0" @click="closeModal">Cancel</button>
            <button class="approve-btn univ-btn m-0" @click="rejectRequest">Yes Reject</button>
          </div>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>
<script>
import AdminApi from '@/resource/AdminApi'

export default {
  name: "RepRejectModal",
  props: {
    row: {
      required: true,
    },
  },
  data() {
    return {
      form: {
        admin_reason: "",
      },
    };
  },
  methods: {
    reset() {
      this.$emit("update:row", null);
      this.form.admin_reason = ""
    },
    closeModal() {
      this.$bvModal.hide("repRejectModal");
      this.reset();
    },
    rejectRequest() {
      if(!this.form.admin_reason){
        this.$notify("Please enter reason", "error");
        return;
      }

      let url = '/api/v2/rep-info-request/reject-request';
      let loader = this.$loading.show();
      let data = {
        id: this.row.id,
        admin_reason: this.form.admin_reason
      }
      AdminApi.put(url, data)
        .then((res) => {
           console.log(res)
           this.$notify(res.data.message)
           this.$emit("onSuccess")
           this.closeModal()
        })
        .catch((err) => {
          console.log(err)
          this.$notify("Something went wrong. Please try again.", "error");
        }).finally(() => {
        loader.hide()
      })

      
    },
  },
};
</script>
  
  <style>
  .note-txt{
    font-size: 16px;
  }
.request-cancel {
  background: #6c757d;
  color: #fff;
  border-radius: 4px;
  padding: 0.6rem 3rem;
  margin: 0;
  border: none;
}
.try-again {
  color: #12b4de;
  margin-top: 1rem;
  font-weight: 500;
  margin-bottom: 0.8rem;
}
.repRejectModal-form .failed {
  color: red;
}
.repRejectModal-header h4 {
  font-size: 20px;
  color: #2c3f58;
  font-weight: 600;
}
.repRejectModal-header p {
  font-size: 14px;
  color: #2c3f58;
}
.repRejectModal-header button {
  position: absolute;
  top: -15px;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.repRejectModal-form label {
  display: block;
  color: #5e5e5e;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}
.repRejectModal-form .custom-field {
  width: 100%;
  border: 1px solid #dce1e7;
  outline: none;
  border-radius: 6px;
  padding: 9px 15px;
  font-size: 14px;
  transition: all ease 0.6s;
}
.univ-btnEdit,
.univ-btnEdit:focus {
  background: linear-gradient(#0cf, #1597b8 49%, #0567bc);
  border-radius: 6px;
  color: #fff;
  outline: none;
  border: 0;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  margin-top: 10px;
  transition: all ease 0.6s;
  box-shadow: inherit;
}
.modal-content {
  border: 0;
  border-radius: 15px;
}
.modal-header {
  justify-content: center;
  border: 0;
  padding: 25px 0;
  position: relative;
}
.repRejectModal-header .btn-container {
  position: absolute;
  top: -14px !important;
  right: -15px;
  background: #fff;
  color: #000;
  border: 0;
  box-shadow: -2px 2px 13px -4px rgb(0 0 0 / 46%);
  border-radius: 60px;
  font-size: 18px;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  display: flex;
}
</style>
  